import React from 'react';
import { CheckCircle2 } from 'lucide-react';
interface KeyDetailsBlockProps {
  details: {
    label: string;
    value: string;
  }[];
}
export function KeyDetailsBlock({
  details
}: KeyDetailsBlockProps) {
  return <div className="bg-white p-6 md:p-8 border border-club-border rounded-sm" data-id="element-257">
      <h3 className="font-serif text-2xl mb-6 text-club-green border-b border-club-border pb-4" data-id="element-258">
        Key Information
      </h3>
      <div className="space-y-4" data-id="element-259">
        {details.map((detail, index) => <div key={index} className="flex items-start gap-3" data-id="element-260">
            <CheckCircle2 size={20} className="text-club-gold shrink-0 mt-0.5" data-id="element-261" />
            <div data-id="element-262">
              <h4 className="font-medium text-club-ink text-sm uppercase tracking-wider mb-1" data-id="element-263">
                {detail.label}
              </h4>
              <p className="text-club-ink/70 text-sm" data-id="element-264">{detail.value}</p>
            </div>
          </div>)}
      </div>
    </div>;
}